<template>
  <div class="goods_container"
       @click="goDetail(data.id, data.mchtId)">
    <div class="show_image">
      <img :src="data.productPic+'?x-oss-process=image/resize,w_215'"
           alt="">
      <div class="transaction">
        <label v-if="data.tradeFlag === 1" for="" style="background: #eb4444;">闪电发货</label>
        <label v-if="!data.tradeFlag || data.tradeFlag === 0" for="" style="background: #44bdeb;">线下自提</label>

      </div>
    </div>
    <div class="goods_main">
      <div class="show_sn ellipsis">
        {{data.shopName}}
        <span style="margin:0 5px">|</span>{{data.productSn}}
      </div>
      <p class="show_name ellipsis">{{data.productName}}</p>
      <div class="row">
        <p class="show_price">
          <span>¥</span>
          <span>{{data.price}}</span>
        </p>
        <div class="watch">
          <div style="margin-right:1.5vw;">
            <span v-if="data.categorynameleveltwo"
                  class="category_label"
                  @click.stop="goCategory(data)">{{data.categorynameleveltwo}}</span>
          </div>
<!--          <div class="watch_num">
            <img src="@/assets/images/see@2x.png">
            <p class="show_num">{{data.browseNum || 0}}</p>
          </div>-->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    data: Object
  },
  methods: {
    goDetail (productId, mchtId) {
      this.$router.push({
        path: '/shop/goodsDetail',
        query: {
          productId: productId,
          mchtId: mchtId
        }
      })
    },
    // 跳转分类商品
    goCategory (data) {
      this.$router.push({
        path: '/category',
        query: {
          productCategoryIdI: data.lonecategoryid,
          productCategoryId: data.ltwocategoryid
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.watch_num {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  color: #999999;
}

.watch_num img {
  width: 3vw;
  margin-right: 1vw;
}
.category_label {
  padding: 2px;
  border: 1px solid #2d8cf0;
  border-radius: 3px;
  color: #2d8cf0;
}
.watch {
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    font-size: 3vw;
    // font-weight: 400;
  }
}
.transaction{
  position: absolute;
  z-index: 0;
  right: 0;
  top: 3px;
}
.transaction label{
  padding: 2px 10px;
  font-size: 12px;
  border-radius: 10px 0px 0px 10px;
  color: #fff;

}
</style>



// WEBPACK FOOTER //
// src/components/Goods/index.vue